import { ValidationStatus } from '../../../../../../../views/marketing/followers/import';

export default {
  status: {
    [ValidationStatus.Valid]: {
      title: 'Tuontisi on lähes valmis!',
      description: 'Viimeistele tuonti napsauttamalla Jatka-painiketta',
    },
    [ValidationStatus.HasInvalidContent]: {
      title: 'Osa tiedostosi tiedoista puuttuu tai on väärässä muodossa',
      description:
        'Korjaa alla olevat virheet ja lataa tiedosto uudelleen, tai jatka ohittaen virheelliset rivit/solut',
    },
    [ValidationStatus.Invalid]: {
      title: 'Ladattua tiedostoa ei voida käsitellä',
      description: 'Korjaa alla olevat virheet ja yritä uudelleen',
    },
  },
  sections: {
    heading_validation: {
      title: 'Sarakkeiden nimissä/järjestyksessä havaittiin ristiriita:',
      rules: {
        Exact:
          'Sarakkeen #{{column}} on oltava mukana ja sen on oltava nimeltään tarkalleen <strong>{{expected}}</strong>',
      },
    },
    content_validation: {
      title: 'Seuraavat virheet havaittiin:',
      labels: {
        row: 'Rivi <strong>#{{row}}:</strong>',
        imported_rows_one: '{{count}} rivi tuodaan',
        imported_rows_other: '{{count}} riviä tuodaan',
        ignored_rows_one: '{{count}} rivi ohitetaan',
        ignored_rows_other: '{{count}} riviä ohitetaan',
      },
      fields: {
        email: 'Sähköposti',
        phone_number: 'Puhelinnumero',
        first_name: 'Etunimi',
        last_name: 'Sukunimi',
        birthday: 'Syntymäpäivä',
      },
      rules: {
        Required: 'Kenttä {{field}} on pakollinen. Rivi ohitetaan',
        Email: 'Kentän {{field}} tulee olla kelvollinen sähköpostiosoite. Rivi ohitetaan',
        Phone: 'Kentän {{field}} tulee olla puhelinnumero kansainvälisessä muodossa. Kenttä ohitetaan',
        Date: 'Kentän {{field}} tulee olla kelvollinen päivämäärä. Kenttä ohitetaan',
      },
    },
  },
  buttons: {
    back_to_upload: 'Takaisin lataukseen',
    proceed: 'Jatka',
  },
  toasts: {
    error: 'Jokin meni pieleen, ota yhteyttä tukeen',
  },
};
